exports.defaultTypeNameFromMapping = (mapping) => {
  const match =
    Object
      .entries(mapping.types)
      .find(entry => {
        const [typeName, typeDef] = entry
        return typeDef.is_default === true
      })

    return match && match[0]
  }
